import UiConfigButton from "../../atomic/UiConfigButton/UiConfigButton";
import Button from "../../atomic/Button";
import UiConfigCardItem from "../UiConfigCardView";
import Item from "../UiConfigCardView/Item";
import {
  getValueOfKeyFromConfig,
  getDynamicClientSideInput,
  checkVisibility,
  sortButtonsByPosition
} from "../../../services/ApiResponseMiddleware";
import { useBuildPanel } from "../BuilderPanel/useBuildPanel";
import Status from "../UiConfigCardView/Status";
import { useState } from "react";
interface UiConfigCardSectionProps {
  sectionData: any;
  items: any[];
  loanApplicationID: string;
  userID: string;
  token: string;
  pageName: string;
  isLenderDashboard: boolean;
  graphQLResponse: any;
  uiElements?: any;
  tabName: string;
  onDataRefresh: () => void;
  onCardActionClick: (btnId: string, cardDetails: any, action?: any) => void;
  activeTab?: string;
  whiteLabelStyle?: any;
  isColending?: boolean;
}

export default function UiConfigCardSection({
  sectionData,
  items,
  loanApplicationID,
  userID,
  token,
  pageName,
  isLenderDashboard,
  tabName,
  onDataRefresh,
  onCardActionClick,
  activeTab,
  whiteLabelStyle,
  isColending = false
}: UiConfigCardSectionProps) {
  const panelTitle =
    sectionData?.componentLabel || sectionData?.label || "Form";

  const [selectedCardIdName, setSelectedCardIdName] = useState("");

  const { handleClickFinished, builderPanelNode } = useBuildPanel({
    title: panelTitle,
    token,
    pageName,
    activeTab,
    whiteLabelStyle,
    isLenderDashboard,
    staticContext: {
      loanApplicationData: {
        loanApplicationID,
        userID,
        sectionID: sectionData?.id,
        resourceName: tabName
      }
    },
    onDataRefresh,
    selectedCardIdName
  });

  const visibleButtons = sectionData?.buttonList
    ? sortButtonsByPosition(
        Object.entries(sectionData.buttonList).filter(
          ([_, btn]: [string, any]) => checkVisibility(btn)
        )
      )
    : [];

  return (
    <>
      {/* We might need to render TopLevelComponents component here */}
      {visibleButtons.length > 0 && !isColending && (
        <div className="flex justify-end gap-3 mb-4 mt-2">
          {visibleButtons.map(([btnKey, btn]: [string, any]) => (
            <UiConfigButton
              key={btnKey}
              buttonConfig={{ key: btnKey, ...btn }}
              clientSideInput={{
                loanApplicationID: loanApplicationID || "",
                token: token || "",
                userID: userID || ""
              }}
              loanApplicationID={loanApplicationID || ""}
              tabName={tabName || ""}
              isLenderDashboard={isLenderDashboard || false}
              onClickFinished={handleClickFinished}
            />
          ))}
        </div>
      )}

      <div className="flex flex-col w-full">
        {items?.map((item: any, idx: number) => {
          const cardTitle =
            getValueOfKeyFromConfig(item?.nestedfieldList, "partner_name") ||
            getValueOfKeyFromConfig(item?.nestedfieldList, "task_name") ||
            item.label;

          const remarkValue = getValueOfKeyFromConfig(
            item?.nestedfieldList,
            "remarks"
          );

          const requestID: string | undefined = item?.requestID;

          const getVisibility = (field: any) =>
            field?.visible?.isVisible !== false;

          const itemVisibleButtons: [string, any][] = item?.buttonList
            ? Object.entries(item.buttonList).filter(
                ([_, btn]: [string, any]) => getVisibility(btn)
              )
            : [];

          const cardBody = item.nestedfieldList
            ?.filter(
              (nested: any) =>
                getVisibility(nested) &&
                nested.id !== "partner_name" &&
                nested.id !== "task_name"
            )
            .map((nested: any) => (
              <Item
                key={nested.id}
                title={nested.label}
                icon={nested.icon}
                original={
                  nested.value === null ||
                  nested.value === undefined ||
                  nested.value === ""
                    ? "-"
                    : String(nested.value)
                }
              />
            ));

          const cardFooter =
            itemVisibleButtons.length > 0 || item?.tag?.visible?.isVisible ? (
              <div className="flex flex-wrap items-center justify-between gap-4 w-full">
                <div className="flex items-center">
                  {item?.tag?.visible?.isVisible && (
                    <Status
                      label={item?.tag?.label}
                      value={item?.tag?.value || "NA"}
                    />
                  )}
                </div>
                <div className="flex flex-wrap items-center gap-4">
                  {itemVisibleButtons.map(([btnId, btn]: [string, any]) => {
                    // Separate case for Initiate and Timelines button
                    if (btnId === "initiate" || btnId === "timelines") {
                      return (
                        <Button
                          key={btnId}
                          color="primary"
                          onClick={() =>
                            onCardActionClick?.(
                              btnId,
                              {
                                id: cardTitle,
                                title: cardTitle,
                                description: remarkValue
                              },
                              btn?.action
                            )
                          }
                        >
                          {btn?.label || btn?.hoverString}
                        </Button>
                      );
                    }

                    return (
                      <UiConfigButton
                        key={btnId}
                        buttonConfig={{ key: btnId, ...btn }}
                        clientSideInput={{
                          ...getDynamicClientSideInput(btn, item),
                          loanApplicationID: loanApplicationID,
                          token: token,
                          userID: userID,
                          requestID: requestID!
                        }}
                        loanApplicationID={loanApplicationID}
                        tabName={tabName}
                        isLenderDashboard={isLenderDashboard || false}
                        onClickFinished={(response, buttonConfig) => {
                          handleClickFinished(response, buttonConfig);
                          setSelectedCardIdName(item?.id);
                        }}
                        notifySuccess={false}
                      />
                    );
                  })}
                </div>
              </div>
            ) : null;

          return (
            <UiConfigCardItem
              key={item?.id || `card-${idx}`}
              title={cardTitle}
              footer={cardFooter}
            >
              {cardBody}
            </UiConfigCardItem>
          );
        })}
      </div>
      {builderPanelNode}
    </>
  );
}
